// extracted by mini-css-extract-plugin
module.exports = {"warning":"Poll_warning__2Ayz3"};